import React from 'react';
import {Result, Button} from "antd";
import { useNavigate } from "react-router-dom";

function NotAllowed(props) {
    const navigate = useNavigate();
    return (
        <Result
        status="403"
        title="403"
        subTitle="شما اجازه دسترسی به این صفحه را ندارید!"
        extra={<Button type="primary"  onClick={() => navigate(-1)}>بازگشت</Button>}
      />
    );
}

export default NotAllowed;